import { createContext } from 'react'

export const ScrollSliderContext = createContext()
